module.exports = __webpack_public_path__ + "img/cooperate4.a7dacfc8.png";